/** Keep already-typed characters when the target grows or is lightly edited. */
export function continueStreamReveal(current, goal) {
  const from = String(current ?? '')
  const to = String(goal ?? '')
  if (!from) return ''
  if (to.startsWith(from)) return from
  if (from.startsWith(to)) return to
  let index = 0
  const limit = Math.min(from.length, to.length)
  while (index < limit && from.charCodeAt(index) === to.charCodeAt(index)) index += 1
  return from.slice(0, index)
}
